<div class="row" *ngFor="let single of singles; let odd=odd; let i = index;" [class.odd-row]="odd">
  <div class="right-side">
    <div class="running-time">{{secondsToMinutes(single.runningTime)}}</div>
    <div *ngIf="getPrice(single.price, single.currency)" class="price" (click)="priceClicked(single)">{{getPrice(single.price, single.currency)}}</div>
    <div *ngIf="single.availableOnlyWithAlbum == 1" class="only-with-album">{{getString('withAlbumOnly')}}</div>
  </div>
  <div class="single-title" (click)="singleClicked($event, single)" (auxclick)="singleClicked($event, single)">{{i+1}}. {{single.title}}</div>
</div>